import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { Box, Typography, TypographyProps, useTheme } from "@mui/material";
import { MiIcon } from "../MiIcon/MiIcon";

interface MiPlaceholderIconProps {
  image?: string;
  icon: string;
  iconColor?: string;
  iconBgColor?: string;
  text: string;
  helperText?: string;
  textProps?: TypographyProps;
  helperTextProps?: TypographyProps;
}

export const MiPlaceholderIcon = memo(
  ({
    image,
    icon,
    iconColor,
    iconBgColor,
    text,
    helperText = "",
    textProps,
    helperTextProps,
  }: MiPlaceholderIconProps) => {
    const { classes } = useStyles({ iconBgColor, isImage: !!image });
    const theme = useTheme();

    return (
      <Box className={classes.placeholderContainer}>
        <Box className={classes.iconContainer}>
          {image ? (
            <img src={image} alt="placeholder" />
          ) : (
            <MiIcon
              path={icon}
              color={iconColor}
              size={1.5}
              style={{
                padding: theme.spacing(1),
              }}
            />
          )}
        </Box>
        <Box className={classes.textContainer}>
          <Typography
            variant="h6"
            color={theme.palette.text.primary}
            fontWeight={theme.fontWeight.medium}
            fontSize={theme.fontSize.large}
            {...textProps}
          >
            {text}
          </Typography>
          {helperText && (
            <Typography
              variant="body1"
              color={theme.palette.text.secondary}
              fontWeight={theme.fontWeight.regular}
              fontSize={theme.fontSize.medium}
              {...helperTextProps}
            >
              {helperText}
            </Typography>
          )}
        </Box>
      </Box>
    );
  }
);

const useStyles = makeStyles<{ iconBgColor?: string; isImage: boolean }>()(
  (theme, { iconBgColor, isImage }) => ({
    placeholderContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: isImage ? 0 : theme.spacing(4),
    },
    iconContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: 60,
      height: 60,
      borderRadius: 100,
      backgroundColor: iconBgColor || theme.palette.grey.accent,
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
  })
);
